module.exports = __webpack_public_path__ + "img/flor_3.6c77dbc8.svg";